import React from 'react'
import { Link } from "react-router-dom";
import './navBar.scss'

// Convert siteInfo to an H1 style for the brand title
function h1Style(siteInfo) {
  var style = {};

  if(!!siteInfo.h1_left) {
    style.left = siteInfo.h1_left;
    style.position = 'relative'
  }

  if(!!siteInfo.h1_top) {
    style.top = siteInfo.h1_top;
    style.position = 'relative'
  }

  return style;
}

// Convert siteInfo to an img style for the brand logo
function imgStyle(siteInfo) {
  var style = {};

  if(!!siteInfo.img_left) {
    style.left = siteInfo.img_left;
    style.position = 'relative'
  }

  if(!!siteInfo.img_top) {
    style.top = siteInfo.img_top;
    style.position = 'relative'
  }

  if(!!siteInfo.img_height) {
    style.height = siteInfo.img_height;
  }

  if(!!siteInfo.img_width) {
    style.width = siteInfo.img_width;
  }

  return style;
}

const NavBar = ({ siteInfo, error }) => ( 
  <div className="nav-header" style={{backgroundColor: siteInfo.backgroundColor}}>
    <div className="nav-brand" style={{backgroundColor: siteInfo.backgroundColor}}>
      {!!siteInfo.img && <img style={imgStyle(siteInfo)} src={siteInfo.img} />}
      {!!siteInfo.show_brand_name && <h1 style={h1Style(siteInfo)} className="nav-title">{siteInfo.title}</h1>}
    </div>
    {!!error && <div className='error'>{error}</div>}
    {/* <i className="fa fa-bars fa-3x"></i>
    <div className="header-links">
      <ul>
        <li data-menuanchor="fourthPage"><Link to="/"> Home</Link></li>
        <li data-menuanchor="thirdPage"><Link to="/about">About</Link></li>
      </ul>
    </div> */}
  </div>
)

export default NavBar